<template>
  <div class="home">
    <div class="qr">
      <div class="qr_header">
        <img src="@assets/images/touxiang_kefu.png">
        <span class="qr_title">邀工网客服</span>
      </div>
      <div class="qr_img">
        <img src="@assets/images/kefu_qr.jpg">
      </div>
      <div class="qr_bottom">
        <div class="qr_bottom_text">长按识别二维码添加</div>
        <div class="qr_bottom_tips">若无法识别可截屏保存后添加</div>
      </div>
    </div>
  </div>
</template>

<script>
import { wxQr } from '@api/wxQr'

export default {
  name: 'index',
  components: {
  },
  data () {
    return {
      cityCode: undefined,
      qrImg: undefined
    }
  },
  created () {
    document.title = '邀工网客服';
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/css/mixin";
.home{
  height: 100%;
  background-color: #F7F8FA;
  padding: 25px;
  display: flex;
  align-items: center;
  .qr{
    width: 100%;
    height: 385px;
    background-color: #FFFFFF;
    margin-top: -60px;
    padding: 16px;
    .qr_header{
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-bottom: 32px;
      img{
        width: 50px;
        height: 50px;
      }
      .qr_title{
        margin-left: 8px;
        font-size: 15px;
      }
    }
    .qr_img{
      height: 200px;
      margin-bottom: 20px;
      img{
        height: 200px;
        width: 200px;
        margin: 0 auto;
      }
    }
    .qr_bottom{
      text-align: center;
      .qr_bottom_text{
        font-size: 17px;
        margin-bottom: 8px;
      }
      .qr_bottom_tips{
        font-size: 14px;
        color: #999999;
      }
    }
  }
}
</style>
